import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Palestinian() {
  return (
    <ApiCommunityDirectoryPage
      community="Palestinian"
      eyebrow="Palestinian community guide"
      title="Palestinian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Palestinian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Palestinian community guide?"
      modalIdPrefix="palestinian-directory"
    />
  );
}
